import React from 'react';
import type { SortItem } from './types';
import { ArrowsChevronsTopIcon } from '../../../ui/Icons/ArrowsChevronsTopIcon';
import { ArrowsChevronsBottomIcon } from '../../../ui/Icons/ArrowsChevronsBottomIcon';

export const SORT_OPTIONS = {
  bestMatch: 'best',
  highestRated: 'rating',
  distance: 'distance',
  priceAscending: 'price-asc',
  priceDescending: 'price-desc',
};

export const SORT_ITEMS: SortItem[] = [
  {
    title: 'Best Match',
    option: SORT_OPTIONS.bestMatch,
    buttonText: 'Best Match',
  },
  {
    title: 'Highest Rated',
    option: SORT_OPTIONS.highestRated,
    buttonText: 'Rating',
  },
  {
    title: 'Distance',
    option: SORT_OPTIONS.distance,
    buttonText: 'Distance',
  },
  {
    title: 'Price: Low to High',
    option: SORT_OPTIONS.priceAscending,
    iconRight: color => (<ArrowsChevronsBottomIcon width={20} height={20} color={color} />),
    buttonText: 'Price',
  },
  {
    title: 'Price: High to Low',
    option: SORT_OPTIONS.priceDescending,
    iconRight: color => (<ArrowsChevronsTopIcon width={20} height={20} color={color} />),
    buttonText: 'Price',
  },
];
